module.exports = __webpack_public_path__ + "static/facebook_logo-d8fe7f7e9c5d3a5ac0a53b08a811d7e9.svg";